export class PlantillaFilter {
  version?: number;
  estructura?: string;
  estaActiva?: boolean;
  tipoDocumentoId?: number;
}
